<template>
  <v-div class="OptionsSelector">
    <v-text-field
      v-model="newChip"
      single-line
      :aria-label="ariaLabel + 's'"
      @keyup.enter="onAddChip"
    >
      <v-div slot="append" rounded width-24 height-24 has-action>
        <a
          href="#"
          role="button"
          :aria-label="`add ${ariaLabel}`"
          class="no-underline"
          @click.prevent="onAddChip"
          @keyup.enter.prevent="onAddChip"
        >
          <v-icon color="primary" aria-hidden="true">{{ mdiPlus }}</v-icon>
        </a>
      </v-div>
    </v-text-field>
    <ul v-if="selected.length" class="no-bullet inline-list">
      <li v-for="(chip, indexNo) in selected" :key="indexNo">
        <v-chip class="mt-2 mr-2">
          {{ chip }}
          <button @click.prevent="onRemoveChip(indexNo)">
            <v-icon right style="font-size: 18px">{{ mdiCloseCircle }}</v-icon>
            <span class="d-sr-only">remove {{ ariaLabel }} {{ chip }}</span>
          </button>
        </v-chip>
      </li>
    </ul>
  </v-div>
</template>

<script>
import { mdiCloseCircle, mdiPlus } from "@mdi/js";

export default {
  name: "OptionsSelector",
  props: {
    selected: { type: Array, default: () => [] },
    ariaLabel: { type: String, default: "item" },
  },
  data: () => {
    return {
      newChip: "",
      // Icons
      mdiCloseCircle,
      mdiPlus,
    };
  },
  methods: {
    onAddChip() {
      const { newChip } = this;

      if (newChip.length === 0) {
        return;
      }

      let oldChips = this.selected ? [...this.selected] : [];

      if (newChip.includes(",")) {
        oldChips = [...oldChips, ...newChip.split(",")];
      } else if (newChip.includes(";")) {
        oldChips = [...oldChips, ...newChip.split(";")];
      } else {
        oldChips.push(newChip);
      }

      this.newChips = oldChips.filter((chip) => !!chip);
      this.newChip = "";

      this.$emit("selectionUpdated", this.newChips);
    },
    onRemoveChip(index) {
      const newChips = this.selected ? [...this.selected] : [];

      if (index < newChips.length) {
        newChips.splice(index, 1);

        this.newChips = newChips;
      }

      this.$emit("selectionUpdated", this.newChips);
    },
  },
};
</script>
